<template>
  <div>
    <v-toolbar class="header-element mt-2" dense>
      <v-toolbar-title>Destinatarios</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-layout row wrap v-if="(clubs.length && personCriteria.length) || grupos.length">
        <v-flex sm6 xs12 v-if="personCriteria.length">
          <v-subheader>Grupos comunicados</v-subheader>
          <v-list>
            <v-list-tile v-for="group in personCriteria" :key="group.id">
              <v-list-tile-content>
                <v-list-tile-title v-text="group.nombre" class="pl-2"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <template v-if="$vuetify.breakpoint.smAndUp">
          <v-divider vertical></v-divider>
        </template>
        <template v-else>
          <v-flex ma-1 pa-0><v-divider></v-divider></v-flex>
        </template>
        <v-flex sm5 xs12 v-if="clubs.length">
          <v-subheader>Clubes</v-subheader>
          <v-list>
            <v-list-tile v-for="club in clubs" :key="club.id">
              <v-list-tile>
                <img :src="club.logo" width="25" class="logo">
              </v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title v-text="club.nombre"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
      <template v-if="grupos && grupos.length">
        <v-divider></v-divider>
        <v-flex>
          <v-subheader>Grupos predeterminados</v-subheader>
          <v-list>
            <v-list-tile v-for="group in grupos" :key="group.id">
              <v-list-tile-content>
                <v-list-tile-title v-text="group.nombre" class="pl-2"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </template>
      <template v-if="emails && emails.length">
        <v-divider></v-divider>
        <v-flex>
          <v-subheader>Emails</v-subheader>
          <v-card-title class="pl-4">{{ emailsJoined }}</v-card-title>
        </v-flex>
      </template>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    clubs: Array,
    personCriteria: Array,
    emails: Array,
    grupos: Array
  },

  computed: {
    emailsJoined () {
      return this.emails.join(' - ')
    }
  }
}
</script>

<style scoped>
.header-element {
  background-color: #293968;
  color: white;
}
</style>
